<script>
import Layout from "../../layouts/main.vue";
import PageHeader from "@/components/page-header";
import appConfig from "../../../app.config";
import axios from 'axios';
import DataTable from 'datatables.net-vue3';
import moment from 'moment';
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import Multiselect from "@vueform/multiselect";
import "@vueform/multiselect/themes/default.css";
import { usePermissions } from "@/composables/usePermissions";

export default {
    page: {
        title: "Order Fulfilment",
        meta: [{ name: "description", content: appConfig.description }],
    },

    setup() {
        const { canReadOrderFulfillment, canExportOrderFulfillment } = usePermissions();
        return {
            canReadOrderFulfillment,
            canExportOrderFulfillment,
        };
    },

    data() {
        return {
            role: localStorage.getItem('role'),
            title: "Order Fulfilment",
            items: [
                {
                    text: "Order Fulfilment",
                    href: "/",
                },
            ],

            rangeDateconfig: {
                mode: "range",
                dateFormat: "Y-m-d",
            },
        
            customerOrderList: [],
            loadingRoles: false,
            isButtonDisabled: false,
            date: '',
            key_search: '',
            order_fulfillment_status_id: null,
            orderStatusOptions: [
                { value: '1', label: 'Pending Allocation' },
                { value: '2', label: 'Ready to Ship' },
                { value: '3', label: 'Fulfilled' },
                { value: '4', label: 'Cancelled' },
                { value: '5', label: 'Delivered' },
            ],
            dtKey: 0,
            export_date: '',
            isLoadingExport: false,
            showExportModal: false,
        };
    },

    methods: {
        format_date(value) {
            if (value) {
                return moment(String(value)).format('YYYY-MM-DD HH:mm:ss');
            }
            return '---';
        },

        displayValue(value, prefix = '') {
            if (value === null || value === undefined || String(value).trim() === '' || String(value).trim() === 'NA') {
                return '---';
            }
            return prefix + value;
        },

        fetchOrders() {
            this.loadingRoles = true;
            this.isButtonDisabled = true;

            const params = {};
            if (this.key_search && this.key_search.trim() !== '') {
                params.key_search = this.key_search.trim();
            }
            if (this.date && this.date.trim() !== '') {
                params.date = this.date.trim();
            }
            if (this.order_fulfillment_status_id) {
                if (Array.isArray(this.order_fulfillment_status_id) && this.order_fulfillment_status_id.length > 0) {
                    params.order_fulfillment_status_id = this.order_fulfillment_status_id;
                } else if (!Array.isArray(this.order_fulfillment_status_id) && this.order_fulfillment_status_id !== '') {
                    params.order_fulfillment_status_id = [this.order_fulfillment_status_id];
                }
            }

            axios.defaults.headers.common['authorization'] = 'Bearer ' + localStorage.getItem('jwt');
            axios.get(process.env.VUE_APP_API_BASEURL + 'order-fulfillment', { params })
                .then(response => {
                    if (response && response.data) {
                        // Support paginated structure data.data or plain array
                        const result = response.data.data?.data || response.data.data || [];
                        this.customerOrderList = Array.isArray(result) ? result : [];
                    } else {
                        this.customerOrderList = [];
                    }
                    this.dtKey += 1;
                })
                .catch(error => {
                    console.error('Error fetching order fulfillment:', error);
                    this.customerOrderList = [];
                    this.dtKey += 1;
                })
                .finally(() => {
                    this.loadingRoles = false;
                    this.isButtonDisabled = false;
                });
        },

        openExportModal() {
            this.export_date = this.date || '';
            this.showExportModal = true;
        },

        closeExportModal() {
            this.showExportModal = false;
        },

        downloadExcel() {
            if (!this.export_date || this.export_date.trim() === '') {
                alert('Please select an order date range to export.');
                return;
            }

            this.isLoadingExport = true;

            const params = {
                date: this.export_date.trim(),
            };

            if (this.key_search && this.key_search.trim() !== '') {
                params.key_search = this.key_search.trim();
            }
            if (this.order_fulfillment_status_id) {
                if (Array.isArray(this.order_fulfillment_status_id) && this.order_fulfillment_status_id.length > 0) {
                    params.order_fulfillment_status_id = this.order_fulfillment_status_id;
                } else if (!Array.isArray(this.order_fulfillment_status_id) && this.order_fulfillment_status_id !== '') {
                    params.order_fulfillment_status_id = [this.order_fulfillment_status_id];
                }
            }
            params.format = 'xlsx';

            axios.defaults.headers.common['authorization'] = 'Bearer ' + localStorage.getItem('jwt');
            axios.get(process.env.VUE_APP_API_BASEURL + 'order-fulfillment/export', {
                params,
                responseType: 'blob'
            })
            .then(response => {
                if (response && response.data) {
                    const blob = new Blob([response.data], { 
                        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' 
                    });
                    const fileURL = window.URL.createObjectURL(blob);
                    const fileLink = document.createElement('a');
                    fileLink.href = fileURL;
                    fileLink.setAttribute('download', `Order_Fulfillment_${moment().format('YYYYMMDD_HHmmss')}.xlsx`);
                    document.body.appendChild(fileLink);
                    fileLink.click();
                    document.body.removeChild(fileLink);
                    window.URL.revokeObjectURL(fileURL);

                    this.showExportModal = false;
                }
            })
            .catch(error => {
                console.error('Error exporting order fulfillment:', error);
                alert('Failed to export order fulfillment data. Please try again.');
            })
            .finally(() => {
                this.isLoadingExport = false;
            });
        },

        submitForm(e) {
            if (e) e.preventDefault();
            this.fetchOrders();
        },

        resetForm() {
            this.date = '';
            this.key_search = '';
            this.order_fulfillment_status_id = null;
            this.fetchOrders();
        },

        getFulfillmentStatusName(status)
        {
            let name = 'Pending Allocation'
            switch(status) {
                case 1:
                    name = 'Pending Allocation';
                    break;
                case 2:
                    name = 'Ready to Ship';
                    break;
                case 3:
                    name = 'Fulfilled';
                    break;
                case 4:
                    name = 'Cancelled';
                    break;
                case 5:
                    name = 'Delivered';
                    break;
            }

            return name;
        }
    },

    components: {
        Layout,
        PageHeader,
        DataTable,
        flatPickr,
        Multiselect,
    },

    mounted() {
        this.fetchOrders();
    },
};
require("@/assets/css/datatable.css");
</script>

<style scoped>
.cursor-pointer {
    cursor: pointer;
}
.device-detail-card {
    background-color: #f8f9fa;
    border-radius: 8px;
    padding: 15px;
}
:deep(.search-box input.form-control),
:deep(input.form-control),
:deep(.multiselect) {
    min-height: 38px !important;
    height: 38px !important;
    font-size: 13px !important;
}
:deep(.multiselect) {
    border: 1px solid #ced4da !important;
    border-radius: 0.25rem !important;
}
:deep(.multiselect-placeholder),
:deep(.multiselect-single-label) {
    font-size: 13px !important;
    padding-left: 8px !important;
}
</style>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    
    <div class="card" v-if="canReadOrderFulfillment">
        <div class="card-header border-bottom-dashed">
            <div class="row g-3 align-items-center">
                <div class="col-md">
                    <div>
                        <h5 class="card-title mb-0">Order Fulfilment List</h5>
                        <p class="text-muted mb-0 font-size-12">Manage and view Processing & Processed orders for fulfillment</p>
                    </div>
                </div>
                <div class="col-md-auto" v-if="canExportOrderFulfillment">
                    <div class="d-flex justify-content-end gap-2">
                        <router-link to="/orders/order-fulfillment/import" class="btn btn-success d-flex align-items-center">
                            <i class="ri-file-excel-2-line align-middle me-1"></i> Import Excel
                        </router-link>
                         <!-- Rule 2: user should be able to export the processing order (Triggers Modal Popup) -->
                        <button @click="openExportModal()" class="btn btn-success d-flex align-items-center">
                            <i class="ri-file-excel-2-line align-middle me-1"></i> Export Excel
                        </button> 
                    </div>
                </div>
            </div>
        </div>
        
        <div class="card-body border-bottom-dashed border-bottom">
            <form @submit.prevent="submitForm">
                <div class="row g-3">
                    <div class="col-xl-4">
                        <div class="search-box">
                            <input type="text" class="form-control search"
                            placeholder="Search Order Number, Customer, or Imei" v-model="key_search"/>
                            <i class="ri-search-line search-icon"></i>
                        </div>
                    </div>
                    
                    <div class="col-xl-4">
                        <flat-pickr v-model="date" placeholder="Select Order Date Range" :config="rangeDateconfig"
                        class="form-control"></flat-pickr>
                    </div>

                    <div class="col-xl-4">
                        <Multiselect 
                            placeholder="Filter Order Status" 
                            v-model="order_fulfillment_status_id" 
                            mode="tags" 
                            :close-on-select="true" 
                            :searchable="true"
                            :create-option="false" 
                            :options="orderStatusOptions" 
                        />
                    </div>

                    <div class="col-xl-12">
                        <div class="d-flex justify-content-end gap-2">
                            <button type="submit" class="btn btn-primary" :disabled="isButtonDisabled">
                                <i class="ri-equalizer-fill me-1 align-bottom"></i> Search
                            </button>
                            <button type="button" @click="resetForm" class="btn btn-danger">
                                <i class="ri-refresh-fill me-1 align-bottom"></i> Reset
                            </button>
                        </div>
                    </div>
                </div>
            </form>
        </div>

        <div class="card-body">
            <h6>** Fulfilment data display (Processing / Processed orders only)</h6>
            <div class="live-preview">
                <div class="row align-items-center g-12">
                    <div class="col-lg-12">
                        <div v-if="loadingRoles" class="text-center p-4">
                            <div class="spinner-border text-success" role="status">
                                <span class="sr-only">Loading...</span>
                            </div>
                        </div>
                        <div v-else>
                            <div class="table-responsive">
                                <DataTable :options="{lengthChange: false, searching: false}" :key="dtKey" class="table table-striped table-nowrap mb-0"> 
                                    <thead class="table-secondary">
                                        <tr>
                                            <th>#.</th>
                                            <th scope="col">Order & Status</th>
                                            <th scope="col">Order & Payment Dates</th>
                                            <th scope="col">Hardware Info</th>
                                            <th scope="col">Program, Source & Branch</th>
                                            <th scope="col">Device & Installment</th>
                                            <th scope="col" class="text-center">Action</th>
                                        </tr>
                                    </thead>

                                    <tbody>                        
                                        <tr v-for="(item, index) in customerOrderList" :key="index" class="content align-middle">
                                            <td>{{ index + 1 }}</td>
                                             <!-- Group 1: Order Number & Status -->
                                            <td>
                                                <router-link :to="'/orders/order-fulfillment-details/' + (item.customer_id || item.cid)" target="_blank" class="fw-semibold text-primary font-size-13 text-decoration-underline">
                                                    {{ item.order_number || item.orderId }}
                                                </router-link>
                                                <div class="mt-1">
                                                    <span class="badge bg-light text-dark border font-size-10">
                                                        {{ getFulfillmentStatusName(item.order_fulfillment_status_id) }}
                                                    </span>
                                                </div>
                                            </td>
                                            
                                            <!-- Group 2: Order Date & First Payment Date -->
                                            <td>
                                                <div><i class="ri-calendar-line font-size-11 text-muted me-1"></i>{{ format_date(item.created_at) }}</div>
                                                <small class="text-muted d-block font-size-11" v-if="item.first_payment_date">
                                                    1st Pay: {{ format_date(item.first_payment_date) }}
                                                </small>
                                            </td>

                                            <!-- Group 3: Customer Details -->
                                            <td>
                                                <div class="fw-semibold text-dark font-size-13">
                                                    Imei 1 : {{ item.imei }}
                                                </div>
                                                <small class="text-muted d-block font-size-11" v-if="item.imei_2">
                                                    imei 2 : {{ item.imei_2 }}
                                                </small>
                                                <small class="text-muted d-block font-size-11" v-if="item.serial_number">
                                                    serial Number : {{ item.serial_number }}
                                                </small>
                                                <small class="text-muted d-block font-size-11" v-if="item.serial_number">
                                                    tracking No : {{ item.fulfillment_tracking_no }}
                                                </small>
                                            </td>

                                            <!-- Group 4: Program, Application Source & Branch (3 Lines) -->
                                            <td>
                                                <div class="fw-semibold text-dark">{{ displayValue(item.program_name) }}</div>
                                                <div class="my-1" v-if="item.application_source || item.program_type">
                                                    <span 
                                                        class="badge font-size-10" 
                                                        :class="String(item.application_source || item.program_type).toUpperCase() === 'ONLINE' ? 'bg-soft-success text-success' : 'bg-soft-warning text-warning'"
                                                    >
                                                        <i :class="String(item.application_source || item.program_type).toUpperCase() === 'ONLINE' ? 'ri-global-line me-1' : 'ri-store-2-line me-1'"></i>
                                                        {{ String(item.application_source || item.program_type).toUpperCase() }}
                                                    </span>
                                                </div>
                                                <div>
                                                    <small class="text-muted font-size-11">
                                                        <i class="ri-map-pin-line me-1 text-secondary"></i>{{ displayValue(item.application_branch || item.pickup_branch) }}
                                                    </small>
                                                </div>
                                            </td>

                                            <!-- Group 5: Device Summary, SKU & Monthly Installment -->
                                            <td>
                                                <div class="fw-semibold text-dark">
                                                    {{ displayValue(item.product_name) }}
                                                </div>
                                                <div class="my-1" v-if="item.sku">
                                                    <span class="badge bg-light text-muted border font-size-11 font-monospace">
                                                        {{ item.sku }}
                                                    </span>
                                                </div>
                                                <small class="d-block font-size-11 text-primary fw-medium" v-if="item.monthly_installment">
                                                    RM {{ item.monthly_installment }}/mo
                                                </small>
                                            </td>
                                            
                                            <!-- Action: Navigate to Fulfilment Details Page -->
                                            <td class="text-center">
                                                <router-link :to="'/orders/order-fulfillment-details/' + (item.customer_id || item.cid)" target="_blank" class="btn btn-sm btn-soft-primary" title="View Fulfilment Details">
                                                    <i class="ri-eye-line align-bottom me-1"></i> View Details
                                                </router-link>
                                            </td>
                                        </tr>
                                    </tbody>
                                </DataTable>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- Permission Denied Warning -->
    <div v-else class="card">
        <div class="card-body text-center text-muted p-5">
            <div class="mb-3">
                <i class="ri-shield-keyhole-line text-warning" style="font-size: 48px;"></i>
            </div>
            <h5>Access Denied</h5>
            <p class="text-muted mb-0">You do not have permission to view the Order Fulfilment module.</p>
        </div>
    </div>

    <!-- Export Excel Modal Dialog -->
    <div v-if="showExportModal" class="modal-backdrop fade show"></div>
    <div 
        class="modal fade" 
        :class="{ show: showExportModal }" 
        :style="{ display: showExportModal ? 'block' : 'none' }"
        tabindex="-1" 
        role="dialog"
    >
        <div class="modal-dialog modal-dialog-centered" role="document">
            <div class="modal-content">
                <div class="modal-header bg-light">
                    <h5 class="modal-title">
                        <i class="ri-file-excel-2-line me-2 align-middle text-success"></i>
                        Export Order Fulfilment
                    </h5>
                    <button type="button" class="btn-close" @click="closeExportModal" aria-label="Close"></button>
                </div>
                <div class="modal-body">
                    <p class="text-muted font-size-13 mb-3">
                        Select an order date range to export the processing & processed orders into an Excel file.
                    </p>
                    <div class="mb-3">
                        <label class="form-label fw-medium">Order Date Range <span class="text-danger">*</span></label>
                        <flat-pickr 
                            v-model="export_date" 
                            placeholder="Select Date Range (e.g. 2026-03-01 to 2026-03-31)" 
                            :config="rangeDateconfig"
                            class="form-control"
                        ></flat-pickr>
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-light" @click="closeExportModal">Cancel</button>
                    <button type="button" @click="downloadExcel()" class="btn btn-success" :disabled="isLoadingExport || !export_date">
                        <template v-if="isLoadingExport">
                            <span class="spinner-border spinner-border-sm me-1" role="status"></span> Exporting...
                        </template>
                        <template v-else>
                            <i class="ri-download-2-line align-middle me-1"></i> Download Excel
                        </template>
                    </button>
                </div>
            </div>
        </div>
    </div>
  </Layout>
</template>
